// Nav bar constants
export const NAVBAR_COLLAPSED_WIDTH_PX = "85px"
export const NAVBAR_EXPANDED_WIDTH_PX = "350px"

// Technical constants
export const DEMAND_KW = "Demand"
export const GENERATION_KW = "Generation"

// App bar constants
export const APPBAR_HEIGHT_PX = "80px"
export const SIDE_BAR_NON_MOBILE_WIDTH = "450px"

// Transition timeouts
export const NAV_FADE_TIME_MS = 1800
export const FILTER_TAB_COLLAPSE_MS = 500
export const FILTER_PANEL_SLIDE_MS = 500

// Auth constants
export const IS_AUTHENTICATED = "authenticated"
export const IS_AUTH_CONFIGURING = "configuring"

// Statuses
export const COMPLIANT = "Compliant"
export const UNKNOWN_STATUS = "Unknown"
export const NON_COMPLIANT = "Non-compliant"
export const APPROVED = "Approved"
export const AWAITING_ASSESSMENT = "Awaiting assessment"
export const NON_COMPLIANT_NEW = "Non-compliant for new installations"
export const NON_COMPLIANT_MINOR = "Minor non-compliance"
export const COMPLAINT_CONFORMATION = "Compliant - DNO confirmation required"
export const DRAFT_AMENDMENT = "Draft amendment"
export const DRAFT_DEVICE = "Draft device"

// Transitions
export const SLIDE_IN_TIMEOUT = 700

// Dataset keywords
export const TTR = "TTR"
export const GB_KW = "GB"
export const NI_KW = "NI"

// Database search constants
export const MIN_CAPACITY_KW = "registered_capacity_min"
export const MAX_CAPACITY_KW = "registered_capacity_max"
export const MIN_DEMAND_KW = "max_demand_min"
export const MAX_DEMAND_KW = "max_demand_max"
export const SYSTEM_FILTER_REF_KW = "device_reference"
export const DEVICE_MODEL_FILTER_KW = "model_number"
export const DEMAND_DEVICE_SYSTEM_REF_KW = "system_reference"
export const ORDER_KW = "ascending"
export const ORDER_BY_KW = "sort_by"
export const ASC = "asc"
export const DESC = "desc"
export const TTR_DEFAULT_ORDER_BY = "PublishedDate"
export const DEMAND_DEFAULT_ORDER_BY = "PublishedDate"
export const TTR_DEFAULT_ORDER_DIRECTION = DESC
export const IS_SUBSCRIBED = "is_subscribed"
export const IS_THREAD_UNREAD = "is_thread_unread"

export const LAST_UPDATED = "lastUpdated"
export const IS_SUPPLY_ISSUES = "isSupplyIssues"
export const IS_LOOPED_SUPPLY = "isLoopedSupply"
export const INSTALLER_LAST_UPDATED = "installerLastUpdated"
// Application search constants
export const APPLICATION_ID_KW = "applicationId"
export const ASSESSMENT_TYPE_KW = "searchMode"
export const ORDER_BY_TIMESTAMP = "ascending"
export const DNO_DEFAULT_ORDER_BY = "asc"
export const DNO_DATE_FROM_KW = "createdDateTimeFrom"
export const DNO_DATE_TO_KW = "createdDateTimeTo"
export const INSTALLER_DATE_FROM_KW = "createdDateFrom"
export const INSTALLER_DATE_TO_KW = "createdDateTo"
export const STATUS = "status"
export const ASSIGNED_TO = "assignedTo"
export const READY_FOR_CX = "readyForCx"
export const MIN_GEN_CAPACITY = "minGenCapacity"
export const MAX_GEN_CAPACITY = "maxGenCapacity"
export const MIN_MAX_DEMAND = "minMaxDemand"
export const MAX_MAX_DEMAND = "maxMaxDemand"
export const UPDATED_SINCE = "updatedSince"
export const UPDATED_TO = "updatedTo"
export const ESCALATED_REASON = "escalatedReason"
export const IS_UNREAD = "isUnread"
export const CREATED_DATE = "createdDate"
export const IS_UN_REDACTED_ONLY = "unredactedOnly"
export const IS_REDACTED_ONLY = "redactedOnly"

// Drafts search constants
export const DRAFT_ID = "draftId"
export const DRAFT_UPDATED_DATE_FROM = "updatedDateFrom"
export const DRAFT_UPDATED_DATE_TO = "updatedDateTo"
export const TECHNOLOGY = "technology"
export const INSTALLER_EMAIL = "installerEmail"
export const POSTCODE = "postcode"
export const ADDRESS = "address"
export const STATUS_FROM = "statusFrom"
export const STATUS_TO = "statusTo"

// Draft application completion statuses
export const DRAFT_STATUS_0 = 1
export const DRAFT_STATUS_20 = 20
export const DRAFT_STATUS_40 = 40
export const DRAFT_STATUS_60 = 60
export const DRAFT_STATUS_80 = 80
export const DRAFT_STATUS_100 = 100

// Input types
export const TEXT_INPUT = "TEXT INPUT"
export const DATE_INPUT = "DATE INPUT"
export const CHECKBOX_INPUT = "CHECKBOX INPUT"
export const RADIO_INPUT = "RADIO INPUT"
export const SELECT_INPUT = "SELECT INPUT"

// When the input type is a select, the options are stored in the
// json_schema_extra.options property as follows
// options: {
//     selectOptions: ["str"],
// }
export const SELECT_OPTIONS_KW = "selectOptions"

// Installer web app constants
export const SUPPLEMENTING_INFO_KW = "supplementingInfo"
export const METER_NUMBER_KW = "meterNumber"
export const PHASE_CODE_KW = "phaseCode"
export const METER_NUMBER_LABEL = "Meter Number"

// Misc
export const DATA_DISPLAY_FALLBACK = "Value not available"
export const NA = "N/A"

// Types of LCTs
export const SOLAR_PV = "SOLAR_PV"
export const BATTERY = "BATTERY"
export const EV_V2G = "EVV2G"
export const HEAT_PUMP = "HP"
export const ELECTRIC_BOILER = "EB"
export const AIR_CONDITIONING_UNIT = "ACU"
export const EVCP_AC = "EVCP_AC"
export const EVCP_DC = "EVCP_DC"

// G100 device
export const G100_DEVICE = "G100_DEVICE"

// Types of LCT applications
export const GENERATION_APPLICATION_KW = "Generation"
export const DEMAND_APPLICATION_KW = "Demand"
export const GENERATION_DEMAND_APPLICATION_KW = "Generation and Demand"

// Recognised LCTs display names
export const HP_DISPLAY_NAME = "Heat Pump"
export const EB_DISPLAY_NAME = "Electric Boiler"
export const ACU_DISPLAY_NAME = "Air Conditioning Unit"
export const EVAC_DISPLAY_NAME = "EV Charge Point (AC)"
export const EVDC_DISPLAY_NAME = "EV Charge Point (DC)"
export const BATTERY_DISPLAY_NAME = "Battery Storage"
export const SOLAR_PV_DISPLAY_NAME = "Solar PV"
export const V2G_INVERTER_DISPLAY_NAME = "EV Vehicle to Grid Inverter"

// Pagination
export const APPLICATION_PAGE_SIZE = 30
export const FIRST_PAGE = "FIRST_PAGE"

// Application supply phases - these are assumed values and may not be accurate
// due to dynamic nature of the data. Only to be used with appropriate
// fallback code to ensure if the data model changes, your code does not break.
export const SINGLE_PHASE_ASSUMED = 1
export const THREE_PHASE_ASSUMED = 3
export const SPLIT_PHASE_ASSUMED = "Split Phase"

// NAV_LINK + COMPLIANCE_STATUS_KW + COMLIANCE_STATUS_ID_NON_COMPLIANT
export const COMPLIANCE_STATUS_KW = "compliance_status_id"
export const DEMAND_COMPLIANCE_STATUS_KW = "compliance_status"
export const GEN_COMPLIANCE_STATUS_ID_AWAITING_ASSESSMENT = `${COMPLIANCE_STATUS_KW}=1`
export const GEN_COMPLIANCE_STATUS_ID_NON_COMPLIANT = `${COMPLIANCE_STATUS_KW}=5`
export const DEMAND_COMPLIANCE_STATUS_ID_AWAITING_ASSESSMENT = `${DEMAND_COMPLIANCE_STATUS_KW}=Awaiting+assessment`
export const DEMAND_COMPLIANCE_STATUS_ID_NON_COMPLIANT = `${DEMAND_COMPLIANCE_STATUS_KW}=Non-compliant`
export const DRAFT_GEN_DEVICES_STATUS_ID = `${COMPLIANCE_STATUS_KW}=7`
export const DRAFT_DEMAND_DEVICES_STATUS_ID = `${DEMAND_COMPLIANCE_STATUS_KW}=Draft+device`

// Survey constants
export const CURRENT_QUESTION =
    "How would you rate your experience using Connect Direct?"

export const BELFAST_POST_CODE_AREA = "bt"

// Error code constants
export const UNABLE_TO_GET_MPAN_FROM_ECOES_ERROR_CODE = 597
export const UNABLE_TO_GET_MPAN_FROM_ECOES_ERROR_CODE_STRING = "597"

// popup constants
export const CONFIRM_TITLE = "Are you sure?"

export const DEBOUNCE_MS = 750
